import type { ApiNodeDataVerificationCheck, VerificationCheck } from '@onefootprint/request-types/dashboard';
import type { TFunction } from 'i18next';

const verificationCheckPriority: Record<VerificationCheck['kind'], number> = {
  kyc: 1,
  kyb: 2,
  base_layer: 3,
  business_aml: 4,
  aml: 5,
  neuro_id: 6,
  sentilink: 7,
  curp_validation: 8,
  phone: 9,
  fingerprint: 10,
};

export const getVerificationCheckSubtitle = (
  data: ApiNodeDataVerificationCheck,
  t: TFunction<'playbook-builder'>,
): string => {
  const title: Record<VerificationCheck['kind'], string> = {
    kyc: t($ => $.verificationChecks.kyc.shortTitle),
    kyb: t($ => $.verificationChecks.kyb.run.shortTitle),
    business_aml: t($ => $.verificationChecks.businessAml.shortTitle),
    aml: t($ => $.verificationChecks.aml.shortTitle),
    neuro_id: t($ => $.verificationChecks.fraud.neuroid.shortLabel),
    sentilink: t($ => $.verificationChecks.fraud.sentilink.shortLabel),
    curp_validation: t($ => $.verificationChecks.curpValidation),
    phone: t($ => $.verificationChecks.phoneLookup),
    base_layer: t($ => $.verificationChecks.baselayer.run.shortTitle),
    fingerprint: t($ => $.verificationChecks.fraud.fingerprint.shortLabel),
  };

  return data.verificationChecks
    .sort((a, b) => verificationCheckPriority[a.kind] - verificationCheckPriority[b.kind])
    .map(vc => title[vc.kind])
    .join(', ');
};
